var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { staticClass: "blank", attrs: { label: _vm.label, prop: _vm.prop } },
    [_c("el-input", { attrs: { type: "hidden", resize: "none" } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }